// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"354":"project","530":"page","597":"projects","757":"not-found","841":"studio","946":"news","962":"home"}[chunkId] || chunkId) + "." + {"354":"6ee7f164","530":"7fa79016","564":"b2d31a89","597":"c931a692","757":"8dd0c923","841":"733c2b35","946":"e8a552cb","962":"ee1992d1"}[chunkId] + ".js";
};